<template>
  <Main>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <strong>AAM - MAPPING NEW SALES ASSIGNMENT</strong>
            <div class="d-flex flex-column mt-3">
              <!-- HEADER -->
              <div class="d-flex justify-space-between mb-2" style="width: 100%; font-size: 12px;">
                <div class="mx-1" style="width: 10%;">CUSTOMER ID REF</div>
                <div class="mx-1" style="width: 20%;">CUSTOMER NAME</div>
                <div class="mx-1" style="width: 7.5%;">BISNIS</div>
                <div class="mx-1" style="width: 7.5%;">TYPE DESC</div>
                <div class="mx-1" style="width: 19%;">POSITION</div>
                <div class="mx-1" style="width: 19%;">ADD SALESMAN POSITION</div>
                <div class="mx-1" style="width: 12%;">START DATE</div>
                <div class="mx-1" style="width: 12%;">END DATE</div>
              </div>
              <!-- ROW -->
              <div v-for="(item, index) in arrRow" :key="index" class="d-flex">
                <v-autocomplete
                  v-model="arrRow[index].customerId"
                  :items="customerList"
                  item-text="CUSTOMER_NAME"
                  item-value="CUSTOMER_ID"
                  class="mx-1"
                  style="width: 10.3%;"
                  @change="onCustomerSelected($event, index)"
                  solo
                ></v-autocomplete>
                <!-- <v-text-field
                  v-model="arrRow[index].customerId"
                  class="mx-1"
                  style="width: 10%;"
                  type="number"
                  solo
                ></v-text-field>-->
                <v-text-field
                  v-model="arrRow[index].customerName"
                  class="mx-1"
                  style="width: 20%;"
                  solo
                ></v-text-field>
                <v-text-field v-model="arrRow[index].bisnis" class="mx-1" style="width: 7.5%;" solo></v-text-field>
                <v-autocomplete
                  v-model="arrRow[index].typeDesc"
                  :items="typeDescList"
                  item-text="TYPE_DESC"
                  item-value="TYPE_CODE"
                  class="mx-1"
                  style="width: 10.3%;"
                  @change="onTypeDescSelected($event, index)"
                  solo
                ></v-autocomplete>
                <!-- <v-text-field
                  v-model="arrRow[index].typeDesc"
                  class="mx-1"
                  style="width: 7.5%;"
                  solo
                ></v-text-field>-->
                <v-text-field
                  v-model="arrRow[index].position"
                  class="mx-1"
                  style="width: 19%;"
                  solo
                ></v-text-field>
                <v-text-field
                  v-model="arrRow[index].addSalesmanPosition"
                  class="mx-1"
                  style="width: 19%;"
                  solo
                ></v-text-field>

                <v-text-field
                  v-model="arrRow[index].startDate"
                  class="mx-1"
                  style="width: 12%;"
                  solo
                  @click="isOpenStartDatepicker = true, indefOfStartDateChoosen = index, pickedStartDate = arrRow[index].startDate"
                ></v-text-field>

                <v-text-field
                  v-model="arrRow[index].endDate"
                  class="mx-1"
                  style="width: 12%;"
                  solo
                  @click="isOpenEndDatepicker = true, indefOfEndDateChoosen = index, pickedEndDate = arrRow[index].endDate"
                ></v-text-field>
              </div>
              <div class="d-flex justify-center">
                <v-btn @click="addRow" small class="mx-1" color="warning">ADD ROW</v-btn>
                <v-btn @click="deleteRow" small class="mx-1" color="error">DELETE ROW</v-btn>
              </div>
              <div class="mt-8">
                <v-btn @click="confirmModal(submit)" block color="success">S U B M I T</v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- End Date v-datepicker -->
    <v-dialog v-model="isOpenEndDatepicker" max-width="500px">
      <v-card>
        <v-card-title class="headline">Pick End Date</v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-date-picker
              v-model="pickedEndDate"
              full-width
              :landscape="$vuetify.breakpoint.smAndUp"
              class="mt-4"
            ></v-date-picker>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenEndDatepicker = false">Cancel</v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="isOpenEndDatepicker = false, arrRow[indefOfEndDateChoosen].endDate = pickedEndDate, pickedEndDate = ''"
          >Pick</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Date Date v-datepicker -->

    <!-- Start Date v-datepicker -->
    <v-dialog v-model="isOpenStartDatepicker" max-width="500px">
      <v-card>
        <v-card-title class="headline">Pick Start Date</v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-date-picker
              v-model="pickedStartDate"
              full-width
              :landscape="$vuetify.breakpoint.smAndUp"
              class="mt-4"
            ></v-date-picker>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenStartDatepicker = false">Cancel</v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="isOpenStartDatepicker = false, arrRow[indefOfStartDateChoosen].startDate = pickedStartDate, pickedStartDate = ''"
          >Pick</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Start Date Date v-datepicker -->

    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text>It will save input data to database. Please give confirmation before you continue.</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false">Cancel</v-btn>

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
export default {
  components: {
    Main
  },
  data() {
    return {
      pickedEndDate: "",
      endDateChoosen: "",
      isOpenEndDatepicker: true,
      pickedStartDate: "",
      startDateChoosen: "",
      isOpenStartDatepicker: false,
      isOpenEndDatepicker: false,
      methodAction: "",
      isOpenModalConfirm: false,
      arrRow: [],
      customerList: [],
      typeDescList: [],
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false
    };
  },
  mounted() {
    this.arrRow.push({
      customerId: "",
      customerName: "",
      bisnis: "",
      typeDesc: "",
      position: "",
      addSalesmanPosition: "",
      startDate: "",
      endDate: "",
      userIdUpdate: JSON.parse(localStorage.getItem("userData")).USER_ID
    });
    this.populateCustomerList();
    this.populateTypeDescList();
  },
  methods: {
    populateCustomerList() {
      this.isLoading = true;
      this.$http
        .get("/adjust-incentive/getCustomerList", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(res => {
          this.isLoading = false;
          const { data } = res.data;
          this.customerList = data;
        })
        .catch(err => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    populateTypeDescList() {
      this.isLoading = true;
      this.$http
        .get("/mapping-sales-assignment/listTypeDesc", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(res => {
          this.isLoading = false;
          const { data } = res.data;
          this.typeDescList = data;
        })
        .catch(err => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    confirmModal: function(method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    addRow() {
      this.arrRow.push({
        customerId: "",
        customerName: "",
        bisnis: "",
        typeDesc: "",
        position: "",
        addSalesmanPosition: "",
        startDate: "",
        endDate: "",
        userIdUpdate: JSON.parse(localStorage.getItem("userData")).USER_ID
      });
    },
    deleteRow() {
      this.arrRow.pop();
    },
    submit() {
      const data = this.arrRow.filter(obj => {
        return this.validateRow(obj);
      });
      if (data.length <= 0) {
        this.showSnackbar("Empty data...");
        return;
      }

      this.isLoading = true;
      this.$http
        .post("/mapping-sales-assignment/insert", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(res => {
          const { success, message } = res.data;
          if (success) {
            this.isLoading = false;
            this.arrRow = [];
            this.showSnackbar("Submit Success...");
          } else {
            this.isLoading = false;
            this.showSnackbar(message);
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    validateRow(obj) {
      if (
        obj.customerId != "" &&
        obj.customerName != "" &&
        obj.bisnis != "" &&
        obj.typeDesc != "" &&
        obj.position != "" &&
        obj.addSalesmanPosition != "" &&
        obj.startDate != ""
      ) {
        return true;
      } else return false;
    },
    onCustomerSelected(customerId, index) {
      this.arrRow[index].customerId = customerId;
    },
    onTypeDescSelected(typeDescID, index) {
      this.arrRow[index].typeDesc = typeDescID;
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    }
  }
};
</script>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
